module.exports = __webpack_public_path__ + "static/media/tip_cat_stethoscope_en.66fba503.png";